import React, { useState, useEffect, useRef } from 'react';
import styles from './PedingRules.module.css';

import LayoutDefault from '../../Components/LayoutDefault/LayoutDefault';
import Panel from '../../Components/Panel/Panel';
import PanelListDefault from '../../Components/PanelListDefault/PanelListDefault';
import RemoveIdsNotFound from '../../Components/RemoveIdsNotFound/RemoveIdsNotFound';
import ExecuteAxios from '../../Components/ExecuteAxios/ExecuteAxios';
import ResetVariables from '../../Components/ResetVariables/ResetVariables';
import ApplyAttributes from '../../Components/ApplyAttributes/ApplyAttributes';
import AutomaticallyListedAttributes from '../../Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes';
import { useContext } from 'react';
import { AuthContext } from '../../Contexts/auth';
import LoadingIndicator from '../../Components/LoadingIndicator/LoadingIndicator';
import InputField from '../../Components/Input/InputField';
import OptionsDataByAttributePath from '../../Components/Options/optionsData/OptionsDataByAttributePath';
import { FaList, FaEdit, FaTimes } from 'react-icons/fa';
import Button from '../../Components/Button/Button';
import UploadButton from '../../Components/UploadButton/UploadButton';
import Topics from '../RulesControl/Topics/Topics';

function PedingRules() {
    const { clientSelected, clientSelectedHandled, setClientSelectedHandled } = useContext(AuthContext);
    const [id, setId] = useState(null)
    const [question, setQuestion] = useState(null);
    const [answer, setAnswer] = useState(null);
    const [statusIcon, setStatusIcon] = useState(null);
    const [subjectRuleIdSelected, setSubjectRuleIdSelected] = useState(null);
    const [isActive, setIsActive] = useState('S')

    const [pedingRulesRecords, setPedingRulesRecords] = useState(null)
    const [pedingRulesRecordDetail, setPedingRulesRecordDetail] = useState(null)
    const [selectedsPedingRules, setSelectsPedingRules] = useState([])
    const [updating, setUpdating] = useState(false)
    const [loadingPanel, setLoadingPanel] = useState(false)
    const [subjectsLookup, setSubjectsLookup] = useState(null)
    const subjectsLookupOptions = OptionsDataByAttributePath(subjectsLookup, ['description'], null, true)
    const [activeTab, setActiveTab] = useState('list');
    const isMobile = window.innerWidth <= 786;
    const [descriptionFilter, setDescriptionFilter] = useState(null)
    const [showTopicsModal, setShowTopicsModal] = useState(false)

    const [progress, setProgress] = useState(0);
    const [status, setStatus] = useState(null);
    const [error, setError] = useState(null);
    const acknowledgedTerminalRef = useRef(false);
    const processingStartRef = useRef(null);

    const FAKE_PROGRESS_DURATION_MS = 3 * 60 * 1000;
    const FAKE_PROGRESS_CAP = 97;
    const PROCESSING_START_STORAGE_PREFIX = 'pedingRulesProcessingStart_';

    const getProcessingStartStorageKey = () => `${PROCESSING_START_STORAGE_PREFIX}${clientSelected ?? 0}`;

    const computeFakeProgress = () => {
        if (!processingStartRef.current) return 0;
        const elapsed = Date.now() - processingStartRef.current;
        const fakeProgress = (elapsed / FAKE_PROGRESS_DURATION_MS) * FAKE_PROGRESS_CAP;
        return Math.min(FAKE_PROGRESS_CAP, Math.round(fakeProgress));
    };

    const attributeList = [
        { name: "id", value: id, setter: setId, allowsMultipleRecordsSelected: true },
        { name: "question", value: question, setter: setQuestion, style: { height: '250px' }, width: '300px' },
        { name: "answer", value: answer, setter: setAnswer, style: { height: '250px' }, width: '300px' },
        { name: "isStatus", value: statusIcon, setter: setStatusIcon, styleGrid: { justifyContent: 'space-around', display: 'flex', } },
        { name: "subjectRuleId", value: subjectRuleIdSelected, setter: setSubjectRuleIdSelected, comboboxOptions: subjectsLookupOptions, width: '250px' },
        {
            name: "isActive", isVisible: 'N', value: isActive, setter: setIsActive, defaultValue: 'S',
            checks: [
                { field: 'isActive', condition: 'VALUE_EQUALS', arrayValue: ['S'] }
            ]
        },
    ];

    const callToGetPedingRulesGrid = (async () => {
        setUpdating(false)
        await getPedingRulesGrid()
    })

    useEffect(() => {
        if (!showTopicsModal) {
            fetchSubject()
        }
    }, [showTopicsModal]);

    useEffect(() => {
        fetchSubject()
        getPedingRulesDetail(0)
        getPedingRulesGrid()
    }, []);

    useEffect(() => {
        if (!clientSelected || !clientSelectedHandled) return
        setClientSelectedHandled(false)

        callToGetPedingRulesGrid()
    }, [clientSelectedHandled]);

    useEffect(() => {
        callToGetPedingRulesGrid()
    }, [descriptionFilter]);

    useEffect(() => {
        setDetailRecord(selectedsPedingRules)
    }, [selectedsPedingRules]);

    const fetchSubject = async () => {
        const parameters = {
            clientId: clientSelected ?? 0
        };
        setSubjectsLookup(await ExecuteAxios.api('get', '/subject-rules/get-subject-rules-active-lookup/', { params: parameters }));
    };

    async function setDetailRecord(selectedsPedingRules) {
        if (selectedsPedingRules && selectedsPedingRules.length === 1) {
            setUpdating(false)
            await getPedingRulesDetail(selectedsPedingRules[0])
        } else {
            setUpdating(false)
            ResetVariables.resetVariables(attributeList)
        }
    }

    async function getPedingRulesGrid() {
        try {
            setLoadingPanel(true)
            const status = ['P', 'R'];
            const parameters = {
                clientId: clientSelected ?? 0,
                descriptionFilter: descriptionFilter,
                isStatus: status.join(",")
            }
            const pedingRulesRecordsResponse = await ExecuteAxios.api('get', `/condominium-rules/get-condominium-rules-grid/`, { params: parameters });
            setPedingRulesRecords(pedingRulesRecordsResponse);
            RemoveIdsNotFound.remove(pedingRulesRecordsResponse, setSelectsPedingRules, selectedsPedingRules)
        } finally {
            setLoadingPanel(false)
        }
    }

    async function getPedingRulesDetail(selectedUser) {
        const parameters = {
            id: selectedUser
        }
        const pedingRulesRecordsDetail = await ExecuteAxios.api('get', `/condominium-rules/get-condominium-rules-by-id-detail/`, { params: parameters });
        setPedingRulesRecordDetail(pedingRulesRecordsDetail);
        if (pedingRulesRecordsDetail) {
            ApplyAttributes.applyAttributes(pedingRulesRecordsDetail, attributeList, false)
        }
    }

    async function putPedingRules() {
        try {
            setLoadingPanel(true)
            const parameters = {
                id: selectedsPedingRules[0],
                question: question,
                answer: answer,
                clientId: clientSelected ?? 0,
                subjectRuleId: subjectRuleIdSelected,
                isActive: isActive,
                isStatus: 'A'

            }
            return await ExecuteAxios.api('put', `/condominium-rules/`, parameters);
        } finally {
            setLoadingPanel(false)
        }
    }

    const inputDescriptionFilter = () => {
        return (
            <InputField
                setAttribute={setDescriptionFilter}
                value={descriptionFilter}
                readOnly={false}
                disabled={false}
                style={{ marginLeft: '10px', width: '150px', borderRadius: '4px' }}
            />
        )
    }

    async function readFileRegulations(file) {
        try {
            setPedingRulesRecordDetail(true);

            const formData = new FormData();
            formData.append("file", file);
            formData.append("clientId", clientSelected);

            await ExecuteAxios.api(
                'post',
                '/condominium-rules/read-regulations',
                formData,
                false
            );

            await checkProcessStatus();
        } catch (e) {
            console.error(e);
        } finally {
            setPedingRulesRecordDetail(false);
        }
    }

    async function checkProcessStatus() {
        try {
            const parameters = {
                clientId: clientSelected ?? 0
            };
            const response = await ExecuteAxios.api(
                'get',
                '/condominium-rules/get-process-status',
                { params: parameters }
            );

            const currentStatus = response?.status ?? null;

            if (currentStatus === "PROCESSING") {
                if (!processingStartRef.current) {
                    const storageKey = getProcessingStartStorageKey();
                    const stored = Number(localStorage.getItem(storageKey));

                    if (stored) {
                        processingStartRef.current = stored;
                    } else {
                        processingStartRef.current = Date.now();
                        localStorage.setItem(storageKey, String(processingStartRef.current));
                    }
                }
                acknowledgedTerminalRef.current = false;
                setStatus("PROCESSING");
                setProgress(computeFakeProgress());
                setError(null);
                return;
            }

            if (currentStatus === "COMPLETED" || currentStatus === "ERROR") {
                if (acknowledgedTerminalRef.current) return;
                acknowledgedTerminalRef.current = true;
                processingStartRef.current = null;
                localStorage.removeItem(getProcessingStartStorageKey());

                setStatus(currentStatus);
                setProgress(currentStatus === "COMPLETED" ? 100 : response.progress || 0);
                setError(currentStatus === "ERROR" ? response.error : null);

                await getPedingRulesGrid();
                if (currentStatus === "COMPLETED") {
                    await fetchSubject();
                }

                setTimeout(() => {
                    acknowledgedTerminalRef.current = false;
                    setStatus(null);
                    setError(null);
                    setProgress(0);
                }, 3000);
                return;
            }

            if (acknowledgedTerminalRef.current) return;
            processingStartRef.current = null;
            localStorage.removeItem(getProcessingStartStorageKey());
            setStatus(null);
            setError(null);
        } catch (e) {
            console.error(e);
        }
    }

    useEffect(() => {
        checkProcessStatus();

        const interval = setInterval(() => {
            checkProcessStatus();
        }, 3000);

        return () => clearInterval(interval);
    }, [clientSelected]);

    useEffect(() => {
        if (status !== "PROCESSING") return;

        const interval = setInterval(() => {
            setProgress(computeFakeProgress());
        }, 1000);

        return () => clearInterval(interval);
    }, [status]);

    const uploadFileStyle = {
        minWidth: '80px',
        padding: '0px 5px 0px 5px',
        float: 'right',
        color: 'white',
        backgroundColor: '#1650d5',
        fontWeight: '600',
        textAlign: 'center',
        marginLeft: '5px',
        marginRight: '5px',
        fontSize: '0.8em'
    };

    const buttonUploadFile = () => {
        return (
            <UploadButton
                uploadMethod={readFileRegulations}
                buttonName={'Carregar regimento'}
                disabled={false}
                style={uploadFileStyle} />

        )
    }

    const updateStatusButton = () => {
        return (
            <Button
                clickMethod={() => {
                    putUpdateStatus()
                }}
                buttonName={'Ativar perguntas'}
                style={buttonStyle}
                disabled={!selectedsPedingRules || selectedsPedingRules.length === 0}
            />
        )
    }

    const buttonStyle = {
        minWidth: '80px',
        padding: '0px 5px 0px 5px',
        float: 'right',
        color: 'white',
        backgroundColor: !selectedsPedingRules || selectedsPedingRules.length === 0 ? 'rgba(32, 27, 35, 0.53)' : '#1650d5',
        fontWeight: '600',
        textAlign: 'center',
        fontSize: '0.8em'
    };

    async function putUpdateStatus() {
        try {
            setLoadingPanel(true)
            const success = await ExecuteAxios.api('put', `/condominium-rules/update-status/`, {
                selectedIds: selectedsPedingRules
            });

            if (success) {
                setSelectsPedingRules([])
                await getPedingRulesGrid()
            }

            return success;
        } finally {
            setLoadingPanel(false)
        }
    }

    const processingStatusLabels = {
        PROCESSING: 'Processando',
        Completed: 'Concluído',
        ERROR: 'Erro'
    };

    const topicsButtonStyle = {
        minWidth: '80px',
        padding: '0px 5px 0px 5px',
        float: 'right',
        color: 'white',
        backgroundColor: '#1650d5',
        fontWeight: '600',
        textAlign: 'center',
        fontSize: '0.8em'
    };

    const topicsButton = () => {
        return (
            <div style={{ marginRight: '2.5px' }}>
                <Button
                    clickMethod={() => setShowTopicsModal(true)}
                    buttonName={'Tópicos'}
                    style={topicsButtonStyle}
                />
            </div>

        )
    }

    async function deleteCondominiumRules(selectedIds) {
        try {
            setLoadingPanel(true)
            const success = await ExecuteAxios.api(
                'delete',
                `/condominium-rules/`,
                {
                    params: {
                        selectedIds: selectedIds.join(','),
                    }
                }
            );

            if (success) {
                setSelectsPedingRules([])
                await getPedingRulesGrid()
            }

            return success;
        } finally {
            setLoadingPanel(false)
        }
    }

    return (
        <LayoutDefault>
            {(activeTab === 'list' || !isMobile) && (
                <Panel
                    titlePage={'Regras'}
                    className={'main-modal two left'}
                    style={{ display: 'flex', flexDirection: 'column' }}
                    canViewCRUD={true}
                    recordsSelected={selectedsPedingRules}
                    enableDelete={true}
                    canDelete={!!(selectedsPedingRules && selectedsPedingRules.length > 0)}
                    deleteFunction={deleteCondominiumRules}
                    componentRightButtons={
                        (
                            <div style={{ display: 'flex' }}>
                                {updateStatusButton()}
                                {buttonUploadFile()}
                            </div>
                        )}

                    viewOnlyOneRecordCRUD={false}
                    resetVariables={() => { ResetVariables.resetVariables(attributeList) }}
                    dataListedAttributes={pedingRulesRecords}
                    attributeList={attributeList}
                    onUpdateIdSelected={setSelectsPedingRules}
                    componentRightFilter={inputDescriptionFilter()}
                >
                    {status && (
                        <div className={styles.processingCard}>
                            <div className={styles.processingHeader}>
                                <span className={styles.processingLabel}>
                                    Status: <strong>{processingStatusLabels[status] || status}</strong>
                                </span>
                                <span className={styles.processingPercent}>{progress}%</span>
                            </div>

                            <div className={styles.progressTrack}>
                                <div
                                    className={`${styles.progressFill} ${status === 'ERROR' ? styles.progressFillError : ''}`}
                                    style={{ width: `${progress}%` }}
                                />
                            </div>
                        </div>
                    )}
                    {error && <div className={styles.errorBox}>{error}</div>}

                    <LoadingIndicator loaded={pedingRulesRecords && !loadingPanel}>
                        <PanelListDefault
                            onUpdateIdSelected={setSelectsPedingRules}
                            idsSelected={selectedsPedingRules}
                            data={pedingRulesRecords}
                            attributeList={attributeList}
                            selectFirstRecord={true}
                            inserting={false}
                            updating={updating}
                        />
                    </LoadingIndicator>
                </Panel>
            )}

            {(activeTab === 'detail' || !isMobile) && (
                <Panel
                    className={'main-modal two right'}
                    titlePage={'Regra selecionada'}
                    style={{ display: 'flex', flexDirection: 'column' }}
                    setUpdating={setUpdating}
                    updating={updating}
                    canEdit={selectedsPedingRules && selectedsPedingRules[0]}
                    enableEdit={true}
                    putFunction={putPedingRules}
                    canViewCRUD={true}
                    recordsSelected={[]}
                    viewOnlyOneRecordCRUD={false}
                    resetVariables={() => { ResetVariables.resetVariables(attributeList) }}
                    dataListedAttributes={pedingRulesRecords}
                    attributeList={attributeList}
                    onUpdateIdSelected={setSelectsPedingRules}
                    componentRightButtons={topicsButton()}
                    cancelFunction={
                        async () => {
                            await setDetailRecord(selectedsPedingRules)
                        }
                    }
                >
                    <LoadingIndicator loaded={pedingRulesRecordDetail && !loadingPanel} >
                        <AutomaticallyListedAttributes
                            list={pedingRulesRecordDetail}
                            attributeList={attributeList}
                            readOnlyAttributes={!updating}
                        />
                    </LoadingIndicator>
                </Panel>
            )}

            {/* Navegação inferior mobile */}
            {isMobile && (
                <div className={styles.bottomNav}>
                    <button
                        className={`${styles.navButton} ${activeTab === 'list' ? styles.active : ''}`}
                        onClick={() => setActiveTab('list')}
                    >
                        <FaList />
                        <span>Lista</span>
                    </button>
                    <button
                        className={`${styles.navButton} ${activeTab === 'detail' ? styles.active : ''}`}
                        onClick={() => setActiveTab('detail')}
                    >
                        <FaEdit />
                        <span>Detalhe</span>
                    </button>
                </div>
            )}

            {showTopicsModal && (
                <div className={styles.topicsModalOverlay} onClick={() => setShowTopicsModal(false)}>
                    <div className={styles.topicsModalBox} onClick={(e) => e.stopPropagation()}>
                        <div className={styles.topicsModalHeader}>
                            <button
                                className={styles.topicsModalClose}
                                onClick={() => setShowTopicsModal(false)}
                                aria-label="Fechar"
                            >
                                <FaTimes />
                            </button>
                        </div>
                        <Topics style={{ display: 'flex', flexDirection: 'column', width: '100%', flex: 1, minHeight: 0 }}
                            titlePage={'Topicos ativos e pendentes'}
                            statusRules={'R'}
                        />
                    </div>
                </div>
            )}
        </LayoutDefault>

    );
}

export default PedingRules;